const jobDescriptions = document.querySelectorAll('.job-rss-feed .jobs-description')

jobDescriptions.forEach((desc) => {
  const btn = desc.querySelector('.show-all')

  const clickHandler = () => {
    btn.remove()
    const h = desc.querySelector('div').clientHeight
    desc.style.height = `${h}px`
    desc.classList.remove('fade-on')
  }

  btn.addEventListener('click', clickHandler)
})